import { withStyles } from '@material-ui/core';

const styles = withStyles(() => ({
  buttonBase: {
    width: '100%',
    background: 'white',
    border: '1px solid #9EB5D9',
    borderRadius: 4,
    padding: 12,
    fontSize: 15,
    fontWeigth: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#0D47A1',
    '&:hover': {
      boxShadow: '0 2px 2px 0 rgba(0,0,0,.18), 0 13px 24px 0 hsla(0,0%,62%,.1)',
      textDecoration: 'underline',
    },

    '& strong': {
      marginBottom: 4,
    },
  },
  buttonDisabled: {
    opacity: 0.4,
  },
}));

export default styles;
